import { request } from '@tencent/ppd-base-libs';

// 拉取货源配置
export function getSkuConfig() {
  return request.loadVtools('https://st.moneydata.hk/res/cc/hkwalletMall/hkwalletMallModule.json');
}
// 拉取实时价格
export function getRealPriceReq(dataType: string) {
  const url = `//apps.wechatpay.com.hk/cgi-bin/charity/price_syn.fcgi?noreport=1&data_type=${dataType}`;
  return request.get(url);
}
